"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var React = __importStar(require("react"));
require("./button.scss");
exports.Button = function (props) {
    var isDisabled = !!props.disabled || props.loading;
    if ("href" in props && !props.disabled) {
        return (React.createElement("a", __assign({ className: getClassNames(props), href: props.href }, (props.target ? { target: props.target } : {})), props.text));
    }
    else {
        return (React.createElement("button", { className: getClassNames(props), onClick: getOnClick(props), disabled: isDisabled }, props.text));
    }
};
function getClassNames(props) {
    var buttonClassNames = [];
    if (props.buttonType) {
        buttonClassNames.push("c-button--" + props.buttonType);
    }
    if (props.loading) {
        buttonClassNames.push("c-button--loading");
    }
    return "c-button " + props.className + " " + buttonClassNames.join(" ");
}
function getOnClick(props) {
    return "onClick" in props ? props.onClick : function () { };
}
exports.Button.defaultProps = {
    buttonType: "primary",
    className: "",
};
//# sourceMappingURL=Button.js.map